import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import api from '../services/api';

const GOLD = '#B8892A';
const INK = '#1A1410';
const INK2 = '#302418';
const INK3 = '#6B5840';
const INK4 = '#A89070';
const BG = '#FAF8F5';
const BD2 = '#EAE5DC';

export default function AuctionFees() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [houses, setHouses] = useState([]);

  useEffect(() => {
    api.get('/auction-houses')
      .then(res => {
        const list = res.data?.houses || res.data || [];
        setHouses(list);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: BG, minHeight: '100vh', paddingBottom: 80 }}>
      {/* Header */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 10, background: '#fff',
        borderBottom: `1px solid ${BD2}`, display: 'flex', alignItems: 'center',
        padding: '12px 16px', gap: 12,
      }}>
        <button onClick={() => navigate(-1)} style={{
          border: 'none', background: 'none', fontSize: 20, cursor: 'pointer',
          color: INK, padding: 0, lineHeight: 1,
        }}>&larr;</button>
        <span style={{ fontSize: 16, fontWeight: 600, color: INK }}>各拍行出品手续费明细</span>
      </div>

      {loading ? (
        <div style={{ padding: '60px 0', textAlign: 'center' }}><Spin size="large" /></div>
      ) : (
        <div style={{ padding: 16 }}>
          <div style={{
            background: '#fff', borderRadius: 10, border: `1px solid ${BD2}`,
            overflow: 'hidden',
          }}>
            {/* Table header */}
            <div style={{
              display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
              padding: '12px 16px', background: BG, borderBottom: `1px solid ${BD2}`,
              fontSize: 12, fontWeight: 600, color: INK3,
            }}>
              <span>拍行</span>
              <span style={{ textAlign: 'center' }}>买方手续费</span>
              <span style={{ textAlign: 'right' }}>备注</span>
            </div>

            {/* Table rows */}
            {houses.map((h, i) => (
              <div key={h.id} style={{
                display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
                padding: '14px 16px', alignItems: 'center',
                borderBottom: i < houses.length - 1 ? `1px solid ${BD2}` : 'none',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {h.logo_url ? (
                    <img src={h.logo_url} alt="" style={{ width: 24, height: 24, borderRadius: 6, objectFit: 'contain' }} />
                  ) : (
                    <div style={{
                      width: 24, height: 24, borderRadius: 6, background: GOLD,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#fff', fontSize: 10, fontWeight: 700,
                    }}>{(h.code || h.name_zh || '?').charAt(0).toUpperCase()}</div>
                  )}
                  <span style={{ fontSize: 13, fontWeight: 500, color: INK2 }}>
                    {h.name_zh || h.code}
                  </span>
                </div>
                <span style={{ textAlign: 'center', fontSize: 13, fontWeight: 600, color: INK }}>
                  {h.buyer_fee_rate ? `${h.buyer_fee_rate}%` : '待更新'}
                </span>
                <span style={{ textAlign: 'right', fontSize: 11, color: INK4 }}>
                  {h.fee_note || '-'}
                </span>
              </div>
            ))}

            {!houses.length && (
              <div style={{ padding: '40px 0', textAlign: 'center', color: INK4, fontSize: 13 }}>
                暂无数据
              </div>
            )}
          </div>

          <p style={{ fontSize: 11, color: INK4, marginTop: 16, lineHeight: 1.8, padding: '0 4px' }}>
            * 以上手续费信息仅供参考，实际费用以各拍行官方公布为准。
          </p>
        </div>
      )}
    </div>
  );
}
